import {forEach} from "../helpers";
import axios from "axios";

export function lk() {
  forEach(document.querySelectorAll('.checkbox-lk-side-settings'), checkbox => {
    checkbox.addEventListener('change', () => {
      console.log('lk ajax request');
      axios.post(checkbox.dataset.url, {
        params: {
          checked: checkbox.checked,
          name: checkbox.name
        }
      })
        .then(function (response) {
          console.log('ok')
        })
        .catch(function (error) {
          alert(error);
        });
    })
  });
}
